<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de Atendimentos">
            <template v-slot:actions>
                <rkm-button
                @click="$router.push({ name: 'atencao-basica-atendimento-individual'})"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="create()"
                    autorize="store-atencao-basica-atendimento-individual"
                    color="primary"
                >
                    Cadastrar atendimento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List
                    :id="id"
                    @loaded="loaded"
                    @paciente="handlePaciente"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Mixins.
import { repository, error, stringCase, unmask } from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Components
import List from '@/components/atencao-basica/atendimento-individual/List'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

export default {
    components: {
        List,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        additionals: null,
        paciente: null,
        enums: {classificacao, subclassificacao},
        cidadao: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loaded(value) {
            this.additionals = value.additionals
            this.cidadao = value.cidadao
        },
        create() {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: this.id}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                        return false
                    }

                    if (this.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                        const confirm = async () => {

                            this.$router.push({ name: 'atencao-basica-atendimento-individual-create', params: { pacienteId: this.id } })

                            return false
                        }

                        const msg = `Paciente com cadastro temporário. Deseja continuar?`

                        this.showConfirmation(msg, confirm)

                        return false
                    }

                    this.$router.push({ name: 'atencao-basica-atendimento-individual-create', params: { pacienteId: this.id } })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePaciente(paciente) {

            this.paciente = paciente
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.cidadao.cidadaoId,
                nome: this.cidadao.nome,
                dataNascimento: this.cidadao.dataNascimento,
                nomeMae: this.cidadao.nomeMae,
                cns: this.cidadao.cns ? this.unMaskCns(this.cidadao.cns) : null,
                cpf: this.cidadao.cpf ? this.unMaskCpf(this.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.cidadao, item)
        },
    },
    mixins: [ repository, error, stringCase, unmask ],
    props: {
        id: { type: Number, default: null }
    },
}
</script>